import { setCssVar } from "quasar";
import { boot } from "quasar/wrappers";
import { Dark } from "quasar";

interface ThemeStyles {
  [property: string]: string;
}

interface Theme {
  [className: string]: ThemeStyles;
}

const isDark = false;
const theme: Theme = {
  "sa-main-nav__button": {
    color: "#dddddd",
    background: "#003200",
  },
  "sa-main-nav__button--badge": {
    background: "blue",
  },

  // dropdowns, dialogs
  "sa-popup": {
    background: "#ffffff",
    color: "#222222",
  },
  "sa-drawer": {
    headerBackground: "#f3f4f6",
    headerTextColor: "#111111",
    background: "#fff",
    color: "#111111",
    footerBackground: "#f3f4f6",
    footerTextColor: "#111111",
  },
  "sa-dialog": {
    background: "#fff",
    color: "#111111",
    headerBackground: "#f3f4f6",
    headerTextColor: "#111111",
    selectedContentRowBackground: "#60EAE9",
    selectedContentRowTextColor: "#111",
  },
  "sa-app-layout": {
    background: "#ffffff",
    color: "#111111",
    mutedColor: "#6b7280",
    linkColor: "#000000",
    headerBorderBottomColor: "#c0c0c0",
    tooltipBackground: "#111",
    tooltipTextColor: "#fff",
  },
  "sa-action-button": {
    buttonBackground: "#111",
    buttonTextColor: "#fff",
    buttonSecondaryBackground: "#f3f4f6",
    buttonSecondaryTextColor: "#111827",
  },
  "sa-main-navigation": {
    buttonBackground: "#e7e7e8",
    activeButtonBackground: "#FED317",
    buttonTextColor: "#111827",
    activeButtonTextColor: "#111827",
    conversationCountBadgeBackgroundColor: "#60EAE9",
    conversationCountBadgeTextColor: "#111",
    tenantSwitcherBackgroundColor: "#faddd9",
    tenantSwitcherTextColor: "#111",
  },
  "sa-toolbar": {
    buttonBackground: "#f3f4f6",
    buttonTextColor: "#111827",
    activeButtonBackground: "#111",
    activeButtonTextColor: "#fff",
    contrastButtonBackground: "#60EAE9",
    contrastButtonTextColor: "#111827",
  },
  "sa-settings-layout": {
    sidebarNavigationBackground: "#f5f5f5",
    sidebarNavigationTextColor: "#111",
    activeSidebarNavigationOptionBackground: "#e5e7eb",
    activeSidebarNavigationOptionTextColor: "#111",
    mainContainerBodyBackground: "#fff",
  },
  "sa-conversation-layout": {
    agentMessageBackground: "#60EAE9",
    agentMessageTextColor: "#1f2937",
    contactMessageBackground: "#f3f4f6",
    contactMessageTextColor: "#1f2937",
    commentBackground: "#FED317",
    commentTextColor: "#1f2937",
  },
  "sa-list": {
    rowBackground: "#fcfcfc",
    rowBackgroundBorder: "#f1f1f1",
    rowTextColor: "#111111",
    hoveredRowBackground: "#f6f6f6",
    hoveredRowTextColor: "#111111",
    selectedRowBackground: "#f1f1f1",
    selectedRowTextColor: "#111111",
  },
};

function setTheme(theme: Theme) {
  for (const [className, styles] of Object.entries(theme)) {
    for (const [property, value] of Object.entries(styles)) {
      const varName = `${className}--${property}`;
      setCssVar(varName, value);
    }
  }
}

export default boot(() => {
  Dark.set(isDark);
  setTheme(theme);
  // setCssVar('text-main-nav-button', '#dddddd')
  // setCssVar('bg-main-nav-button', '#2b5329')
  // setCssVar('sa-dialog__content-row__border-bottom-color', '#649568')
  // setCssVar('sa-dialog__content-row__border-top-color', '#649568')
  // setCssVar('sa-dialog__content-row__background', '#0e6b0e')
});
